var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2544 22.3283C26.9797 20.001 28 17.1196 28 14C28 6.26795 21.7319 0 14 0C6.26795 0 0 6.26795 0 14C0 21.7319 6.26795 28 14 28C18.0566 28 21.7102 26.2747 24.2672 23.5178C24.6174 23.14 24.9471 22.743 25.2544 22.3283ZM24.4782 21C25.8183 18.9978 26.5999 16.5901 26.5999 14C26.5999 7.04122 20.9588 1.39997 13.9998 1.39997C7.04122 1.39997 1.39997 7.04122 1.39997 14C1.39997 16.5903 2.18151 18.9978 3.52179 21C5.21266 18.474 7.79276 16.5934 10.8143 15.8062C9.35539 14.7953 8.39997 13.1093 8.39997 11.1999C8.39997 8.10715 10.9072 5.59988 14 5.59988C17.0928 5.59988 19.6 8.10715 19.6 11.1999C19.6 13.1091 18.6445 14.7953 17.1857 15.8061C20.2071 16.5934 22.7873 18.4738 24.4782 21ZM23.5764 22.1888C21.6116 18.958 18.0579 16.7999 14.0001 16.7999C9.94221 16.7999 6.38836 18.958 4.42359 22.189C6.73451 24.8889 10.1674 26.6 14 26.6C17.8326 26.6 21.2655 24.8888 23.5764 22.1888ZM14 15.4C16.3196 15.4 18.2001 13.5197 18.2001 11.1999C18.2001 8.88027 16.3198 6.99985 14 6.99985C11.6802 6.99985 9.79994 8.88041 9.79994 11.2001C9.79994 13.5197 11.6804 15.4 14 15.4Z",
    fill: "#FF5F37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user-1.43ab2f1a406aa2391f21cfb99259b88f.svg";
export { ForwardRef as ReactComponent };